// Firebase Configuration
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// ⚠️ استبدل هذه البيانات بمعلومات مشروع Firebase الخاص بك
// يمكنك الحصول عليها من: Firebase Console > Project Settings > Your apps
const firebaseConfig = {
  apiKey: "AIzaSyD1x1E3dfHvqYtlBcZEl8GC5g6rRQwuAV8",
  authDomain: "njik.sa",
  projectId: "njik-app",
  storageBucket: "njik-app.appspot.com",
  messagingSenderId: "731458785436",
  appId: "1:731458785436:web:8e015a514202067b7e9d59",
  measurementId: "G-R1FXBEC64G"


};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;
